import sportsEventsAthletesList from '@/store/modules/sports-events-athletes/sports-events-athletes-list'
import sportsEventsAthletesDelete from '@/store/modules/sports-events-athletes/sports-events-athletes-delete'
import sportsEventsAthletesAdd from '@/store/modules/sports-events-athletes/sports-events-athletes-add'

export default {
  sportsEventsAthletesList,
  sportsEventsAthletesDelete,
  sportsEventsAthletesAdd,
}
